<template>
  <div class="container">
    <div class="centerx">
      <vs-popup
        class="holamundo"
        v-bind:title="'Ajuda - Envio/Status'"
        :active.sync="popupActivo"
      >
        <div v-html="textoAjuda"></div>
      </vs-popup>
    </div>
    <div class="card text-center" style="padding:15px;" v-if="content">
      Sua proposta está disponível para envio, clique no botão abaixo para inciar a análise.
        <h4 class="mb-3">Enviar proposta:</h4>
        <h3 class="mb-1">{{content.servicos.abreviacao}} - {{content.servicos.titulo}}
          <br><small>{{content.codigoContratacao}}</small>
        </h3>
        <table class="table">
            <thead>
                <tr>
                    <th class="text-left">Contratação</th>
                    <th class="text-left">Pagamento</th>
                    <th class="text-left">Preenchimento</th>
                    <th class="text-left">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text-left">{{formatData(content.tsContratacao)}}</td>
                    <td class="text-left">{{formatData(content.tsPagamento)}}</td>
                    <td class="text-left" >{{formatData(content.contratacoesEVO13.tsPreenchimento)}}</td>
                    <td class="text-left">{{content.status}}</td>
                </tr>
            </tbody>

        </table>
        <h3 class="text-left">Cadastro da empresa</h3>
        <div class="row text-left">
            <div class="mb-1 col-sm-12">
              <div class="text-primary">RAZÃO SOCIAL</div>
              <div class="text-bold"> {{content.contratacoesEVO01.razaoSocial}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">INCRIÇÃO MUNICIPAL</div>
              <div class="text-bold"> {{content.contratacoesEVO01.inscricaoMunicioal}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">INCRIÇÃO ESTADUAL</div>
              <div class="text-bold"> {{content.contratacoesEVO01.inscricaoEstadual}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CAPITAL SOCIAL</div>
              <div class="text-bold"> {{content.contratacoesEVO01.capitalSocial}}</div>
            </div>
            <div class="col-sm-12">
              <hr>
              <h5 class="text-left">Localização</h5>
            </div>
            <div class="mb-1 col-sm-12">
              <div class="text-primary">LOGRADOURO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.logradouro}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">TIPO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.tipo}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">QUADRA</div>
              <div class="text-bold"> {{content.contratacoesEVO01.quadra}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">BLOCO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.bloco}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">LOTE</div>
              <div class="text-bold"> {{content.contratacoesEVO01.lote}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">NÚMERO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.numero}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">COMPLEMENTO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.complemento}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">CEP</div>
              <div class="text-bold"> {{content.contratacoesEVO01.cep}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">BAIRRO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.bairro}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">CIDADE</div>
              <div class="text-bold"> {{content.contratacoesEVO01.cidade}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">UF</div>
              <div class="text-bold"> {{content.contratacoesEVO01.estado}}</div>
            </div>
            <div class="col-sm-12">
              <hr>
              <h5 class="text-left">Responsável</h5>
            </div>
            <div class="mb-1 col-sm-12">
              <div class="text-primary">NOME DO RESPONSÁVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO01.responsavelNome}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">TELEFONE FIXO</div>
              <div class="text-bold"> {{content.contratacoesEVO01.telefoneFixo}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">TELEFONE CELULAR</div>
              <div class="text-bold"> {{content.contratacoesEVO01.telefoneCelular}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">CPF</div>
              <div class="text-bold"> {{content.contratacoesEVO01.cpf}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">RG</div>
              <div class="text-bold"> {{content.contratacoesEVO01.rg}}</div>
            </div>
             <div class="col-sm-12">
              <hr>
              <h5 class="text-left">Sócios</h5>
            </div>
       </div>
        <div class="text-left row" v-for="(item, index) in content.contratacoesEVO01.contratacoesEVO01A" :key="index">
          <div class="mb-1 col-sm-12">
            <div class="text-primary">NOME DO SÓCIO</div>
            <div class="text-bold"> {{item.socioNome}}</div>
          </div>
          <div class="mb-1 col-sm-6">
            <div class="text-primary">CPF</div>
            <div class="text-bold"> {{item.socioCPF}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PARTICIPAÇÃO</div>
            <div class="text-bold"> {{item.socioParticipacao}}</div>
          </div>
        </div>
          <h3 class="text-left mt-2">Cadastro das obrigações</h3>
        <div>
        <div class="row text-left">
            <div class="mb-1 col-sm-4">
              <div class="text-primary">PORTE DA EMPRESA</div>
              <div class="text-bold"> {{content.contratacoesEVO02.portesEmpresas.titulo}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">REGIME TRIBUTÁRIO</div>
              <div class="text-bold"> {{content.contratacoesEVO02.regimesTributarios.titulo}}</div>
            </div>
            <div class="mb-1 col-sm-10">
              <div class="text-primary">ALIQUOTA SE SIMPLES NACIONAL PERCENTUAL</div>
              <div class="text-bold"> {{content.contratacoesEVO02.aliquota}}</div>
            </div>
             <div class="mb-1 col-sm-2">
              <div class="text-primary">CNAE</div>
              <div class="text-bold"> {{content.contratacoesEVO02.cnae}}</div>
            </div>
            <div class="mb-1 col-sm-6">
              <div class="text-primary">IPTU DA SEDE DA OFICINA</div>
              <div class="text-bold"> {{content.contratacoesEVO02.iptuSedeOficina}}</div>
            </div>
            <div class="mb-1 col-sm-6">
              <div class="text-primary">IPTU DO ESTACIONAMENTO SE TIVER</div>
              <div class="text-bold"> {{content.contratacoesEVO02.iptuEstacionamento}}</div>
            </div>

            <div class="mb-1 col-sm-4">
              <div class="text-primary">SINDICATO PATRONAL</div>
              <div class="text-bold"> {{content.contratacoesEVO02.sindicatoPatronalDescricao}}</div>
            </div>

            <div class="mb-1 col-sm-4">
              <div class="text-primary">PERÍODO</div>
              <div class="text-bold"> {{content.contratacoesEVO02.periodos.titulo}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">SINDICATO CUSTO</div>
              <div class="text-bold"> {{content.contratacoesEVO02.sindicatoPatronalCusto}}</div>
            </div>
       </div>
       <h5 class="text-left mt-3">Cadastro de associações</h5>
        <div class="text-left row" v-for="(item, index) in content.contratacoesEVO02.contratacoesEVO02A" :key="index">
          <div class="mb-1 col-sm-12">
            <div class="text-primary">ASSOCIAÇÃO DESCRIÇÃO</div>
            <div class="text-bold"> {{item.associacaoDescricao}}</div>
          </div>
          <div class="mb-1 col-sm-6">
            <div class="text-primary">CUSTO</div>
            <div class="text-bold"> {{item.associacaoCusto}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
        </div>
        </div>
          <h3 class="text-left mt-2">Dados da edificação</h3>
        <div>
          <div class="row text-left">
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ENDEREÇO FÍSICO - SEDE</div>
              <div class="text-bold"> {{content.contratacoesEVO03.logradouro}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">TIPO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.tipo}}</div>
            </div>
            <div class="mb-1 col-sm-10">
              <div class="text-primary">QUADRA</div>
              <div class="text-bold"> {{content.contratacoesEVO03.quadra}}</div>
            </div>
             <div class="mb-1 col-sm-2">
              <div class="text-primary">BLOCO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.bloco}}</div>
            </div>
            <div class="mb-1 col-sm-6">
              <div class="text-primary">LOTE</div>
              <div class="text-bold"> {{content.contratacoesEVO03.lote}}</div>
            </div>
            <div class="mb-1 col-sm-6">
              <div class="text-primary">NÚMERO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.numero}}</div>
            </div>

            <div class="mb-1 col-sm-4">
              <div class="text-primary">COMPLEMENTO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.complemento}}</div>
            </div>

            <div class="mb-1 col-sm-4">
              <div class="text-primary">CEP</div>
              <div class="text-bold"> {{content.contratacoesEVO03.cep}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">BAIRRO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.bairro}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">UF</div>
              <div class="text-bold"> {{content.contratacoesEVO03.estado}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CIDADE</div>
              <div class="text-bold"> {{content.contratacoesEVO03.cidade}}</div>
            </div>
            <div class="mb-1 col-sm-12">
              <div class="text-primary">LINK GOOGLE MAPS</div>
              <div class="text-bold"> {{content.contratacoesEVO03.linkGoogleMaps}}</div>
            </div>
            <div class="mb-1 col-sm-12">
              <div class="text-primary">FOTOS EXTERNAS</div>
              <div class="row">
                <div class="col-sm-3" v-if="content.contratacoesEVO03.foto1 != null">
                  <img v-bind:src="content.contratacoesEVO03.foto1" alt="" class="img-fluid">
                </div>
                <div class="col-sm-3" v-if="content.contratacoesEVO03.foto2 != null">
                  <img v-bind:src="content.contratacoesEVO03.foto2" alt="" class="img-fluid">
                </div>
                <div class="col-sm-3" v-if="content.contratacoesEVO03.foto3 != null">
                  <img v-bind:src="content.contratacoesEVO03.foto3" alt="" class="img-fluid">
                </div>
                <div class="col-sm-3" v-if="content.contratacoesEVO03.foto4 != null">
                  <img v-bind:src="content.contratacoesEVO03.foto4" alt="" class="img-fluid">
                </div>
              </div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">SEDE ALUGADA:</div>
              <div class="text-bold"> {{content.contratacoesEVO03.sedeAlugada ? 'sim' : 'não'}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">NOME DO PROPRIETÁRIO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.proprietario}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CONTRATO COMODATO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.contratoComodato ? 'sim' : 'não'}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO MERCADO DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO03.valorMercadoImovel}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO MERCADO DO ALUGUEL DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO03.valorMercadoImovelAluguel}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO CONDOMÍNIO</div>
              <div class="text-bold"> {{content.contratacoesEVO03.valorCondominio}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO ALUGUEL (SE PAGO)</div>
              <div class="text-bold"> {{content.contratacoesEVO03.valorAluguel}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ÁREA DO TERRENO DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO03.areaTerreno}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ÁREA CONSTRUIDA DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO03.areaContruida}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ÁREA ÚTIL TOTAL DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO03.areaUtil}}</div>
            </div>
       </div>  
       <hr>
          <h5 class="text-left mt-2">Áreas </h5>
          <div class="text-left mb-1 row" v-for="(item, index) in content.contratacoesEVO03.contratacoesEVO03AR" :key="index">
          <div class="mb-1 col-sm-8">
            <div class="text-primary">NOME DA ÁREA</div>
            <div class="text-bold"> {{item.nome}}</div>
          </div>
          <div class="mb-1 col-sm-2">
            <div class="text-primary">ÁREA EM M2</div>
            <div class="text-bold"> {{item.area}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">FOTO</div>
            <div class="text-bold"><img v-bind:src="item.foto1" alt="" class="img-fluid"></div>
          </div>
        </div>
       <hr>
          <h5 class="text-left mt-2">Setores </h5>
          <div class="text-left mb-1 row" v-for="(item, index) in content.contratacoesEVO03.contratacoesEVO03A" :key="index">
            <div class="mb-1 col-sm-8">
              <div class="text-primary">SETOR</div>
              <div class="text-bold"> {{item.nome}}</div>
            </div>
            <div class="mb-1 col-sm-2">
              <div class="text-primary">ÁREA</div>
              <div class="text-bold"> {{item.area}}</div>
            </div>
            <div class="mb-1 col-sm-3">
              <div class="text-primary">PESSOAS OCUPAM DIARIAMENTE O MESMO ESPAÇO SIMULTANEAMENTE</div>
              <div class="text-bold">{{item.pessoas}}</div>
            </div>
            <div class="mb-1 col-sm-12">
                <div class="text-primary">FOTOS EXTERNAS</div>
                <div class="row">
                  <div class="col-sm-4" v-if="item.foto1 != null">
                    <img v-bind:src="item.foto1" alt="" class="img-fluid">
                  </div>
                  <div class="col-sm-4" v-if="item.foto2 != null">
                    <img v-bind:src="item.foto2" alt="" class="img-fluid">
                  </div>
                  <div class="col-sm-4" v-if="item.foto3 != null">
                    <img v-bind:src="item.foto3" alt="" class="img-fluid">
                  </div>
                </div>
            </div>
        </div>
        <h3 class="text-left mt-3">
           <hr>
          Dados do estacionamento</h3>
        <div class="row text-left">
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ÁREA TOTAL</div>
              <div class="text-bold"> {{content.contratacoesEVO04.arealTotal}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ÁREA ÚTIL</div>
              <div class="text-bold"> {{content.contratacoesEVO04.areaUtil}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CAPACIDADE DE GUARDAR VEÍCULOS</div>
              <div class="text-bold"> {{content.contratacoesEVO04.capacidadeGuardaVeiculo}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ENDEREÇO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.endereco}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">LINK GOOGLE MAPS</div>
              <div class="text-bold"> {{content.contratacoesEVO04.linkGoogleMaps}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">ALUGADO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.alugado ? 'sim' : 'não'}}</div>
            </div>
            <div class="mb-1 col-sm-4">
              <div class="text-primary">PROPRIETÁRIO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.proprietario}}</div>
            </div>       
             <div class="mb-1 col-sm-4">
              <div class="text-primary">TIPO DE CONTRATO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.tipoContrato}}</div>
            </div>             
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO MERCADO DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO04.valorMercadoImovel}}</div>
            </div>  
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO MERCADO DO ALUGUEL DO IMÓVEL</div>
              <div class="text-bold"> {{content.contratacoesEVO04.valorMercadoImovelAluguel}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO CONDOMÍNIO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.valorCondominio}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DO ALUGUEL (SE PAGO)</div>
              <div class="text-bold"> {{content.contratacoesEVO04.valorAluguel}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">SEGURANÇA</div>
              <div class="text-bold"> {{content.contratacoesEVO04.seguranca ? 'sim' : 'não'}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CUSTO SEGURANÇA</div>
              <div class="text-bold"> {{content.contratacoesEVO04.segurancaCusto}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">EQUIPAMENTOS PARA MOVIMENTAÇÃO DOS VEÍCULOS</div>
              <div class="text-bold"> {{content.contratacoesEVO04.equipamentosMovimentacao ? 'sim' : 'não'}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">VALOR DOS EQUIPAMENTOS</div>
              <div class="text-bold"> {{content.contratacoesEVO04.equipamentosMovimentacaoValor}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">SEGURO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.seguro ? 'sim' : 'não'}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">CUSTO DO SEGURO</div>
              <div class="text-bold"> {{content.contratacoesEVO04.seguroPremio}}</div>
            </div>              
            <div class="mb-1 col-sm-4">
              <div class="text-primary">TEMPO MÉDIO (EM MINUTOS) PARA MOVIMENTAR O VEÍCULO NO PÁTIO E LEVAR À OFICINA</div>
              <div class="text-bold"> {{content.contratacoesEVO04.tempoMedioPatioOficina}}</div>
            </div>              
            
         </div>
         <h3 class="text-left mt-3">
           <hr>
           Dados da mão de obra</h3>
          <div class="text-left mb-1 " v-for="(item, index) in content.contratacoesEVO05" :key="index">
            <h4>{{item.nome}}</h4>
            <div class="row">
              <div class="mb-1 col-sm-3">
                <div class="text-primary">REGIME DE CONTRATAÇÃO</div>
                <div class="text-bold"> {{item.regimes.titulo}}</div>
              </div>
              <div class="mb-1 col-sm-2">
                <div class="text-primary">CPF</div>
                <div class="text-bold"> {{item.cpf}}</div>
              </div>
              <div class="mb-1 col-sm-2">
                <div class="text-primary">SALÁRIO</div>
                <div class="text-bold"> {{item.salario}}</div>
              </div>
              <div class="mb-1 col-sm-2">
                <div class="text-primary">DÉCIMO TERCEIRO</div>
                <div class="text-bold"> {{item.decimoTerceiro}}</div>
              </div>
            </div>
            <h5 class="mb-1" v-show="item.contratacoesEVO05A.length > 0">Funções</h5>
            <div class="row" v-for="(funcao, i) in item.contratacoesEVO05A" :key="i" >
              <div class="mb-1 col-sm-3">
                <div class="text-primary">FUNÇÃO</div>
                <div class="text-bold"> {{funcao.funcoes.titulo}}</div>
              </div>
              <div class="mb-1 col-sm-3">
                <div class="text-primary">TEMPO DE TRABALHO</div>
                <div class="text-bold"> {{funcao.tempoNaFuncao}}</div>
              </div>
              <div class="mb-1 col-sm-3">
                <div class="text-primary">JORNADA DE TRABALHO</div>
                <div class="text-bold"> {{funcao.jornadaTrabalho}}</div>
              </div>
            </div>
            <h5 class="mb-1" v-show="item.contratacoesEVO05B.length > 0">Benefícios</h5>
            <div class="row" v-for="(beneficio, i) in item.contratacoesEVO05B" :key="i" >
              <div class="mb-1 col-sm-3">
                <div class="text-primary">BENEFÍCIO</div>
                <div class="text-bold"> {{beneficio.beneficios.titulo}}</div>
              </div>
              <div class="mb-1 col-sm-3">
                <div class="text-primary">Valor</div>
                <div class="text-bold"> {{beneficio.valor}}</div>
              </div>
            </div>
            <hr>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados do custo fixo
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO06" :key="i" >
          <div class="mb-1 col-sm-3">
            <div class="text-primary">CUSTOS FIXOS</div>
            <div class="text-bold"> {{item.custosFixos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR</div>
            <div class="text-bold"> {{item.valor}}</div>
          </div>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados do custo varável
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO07" :key="i" >
          <div class="mb-1 col-sm-3">
            <div class="text-primary">CUSTOS VARIÁVEIS</div>
            <div class="text-bold"> {{item.custosVariaveis.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR</div>
            <div class="text-bold"> {{item.valor}}</div>
          </div>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados do insumo de produção
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO08" :key="i" >
          <div class="mb-1 col-sm-3">
            <div class="text-primary">INSUMOS DE PRODUÇÃO</div>
            <div class="text-bold"> {{item.isumosProducao.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR</div>
            <div class="text-bold"> {{item.valor}}</div>
          </div>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados da ferramenta
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO09" :key="i" >
          <div class="mb-1 col-sm-3">
            <div class="text-primary">FERRAMENTA</div>
            <div class="text-bold"> {{item.ferramentas.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR AQUISIÇÃO</div>
            <div class="text-bold"> {{item.valorAquisicao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">DATA DA AQUISIÇÃO</div>
            <div class="text-bold"> {{item.dataAquisicao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR NOVO</div>
            <div class="text-bold"> {{item.valorNovo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">CUSTO MANUTENÇÃO</div>
            <div class="text-bold"> {{item.custoManutencao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">ANOS VIDA ÚTIL</div>
            <div class="text-bold"> {{item.anosVidaUtil}}</div>
          </div>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados do ativo fixo
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO10" :key="i" >
          <div class="mb-1 col-sm-3">
            <div class="text-primary">ATIVO</div>
            <div class="text-bold"> {{item.ativosFixos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR AQUISIÇÃO</div>
            <div class="text-bold"> {{item.valorAquisicao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">DATA DA AQUISIÇÃO</div>
            <div class="text-bold"> {{item.dataAquisicao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR NOVO</div>
            <div class="text-bold"> {{item.valorNovo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">CUSTO MANUTENÇÃO</div>
            <div class="text-bold"> {{item.custoManutencao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">PERÍODO</div>
            <div class="text-bold"> {{item.periodos.titulo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">ANOS VIDA ÚTIL</div>
            <div class="text-bold"> {{item.anosVidaUtil}}</div>
          </div>
        </div>
        <h3 class="text-left mt-3">
          <hr>
          Dados dos veículos.
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO11" :key="i" >
          <h5 class="col-sm-12">{{item.marcas.titulo}} - {{item.marcasModelos.titulo}}</h5>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">ANO FABRICAÇÃO</div>
            <div class="text-bold"> {{item.anoFabricacao}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">ANO DO MODELO</div>
            <div class="text-bold"> {{item.anoModelo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR DE MERCADO</div>
            <div class="text-bold"> {{item.valorMercado}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR NOVO</div>
            <div class="text-bold"> {{item.valorNovo}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR IPVA</div>
            <div class="text-bold"> {{item.valorIpva}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR SEGURO</div>
            <div class="text-bold"> {{item.valorSeguro}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">VALOR MANUTENÇÃO MENSAL</div>
            <div class="text-bold"> {{item.valorManutencaoMensal}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">FINALIDADE</div>
            <div class="text-bold"> {{item.finalidade}}</div>
          </div>
        </div>        
        <h3 class="text-left mt-3">
          <hr>
          Dados da produção
        </h3>       
        <div class="row text-left" v-for="(item, i) in content.contratacoesEVO12" :key="i" >
          <h5 class="col-sm-12">{{item.servicos.titulo}}</h5>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">QTDE. HORAS MÁXIMAS POR MÊS</div>
            <div class="text-bold"> {{item.maxHorasMes}}</div>
          </div>
          <div class="mb-1 col-sm-3">
            <div class="text-primary">QTDE. HORAS MÍNIMA POR MÊS</div>
            <div class="text-bold"> {{item.minHorasMes}}</div>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import { getSuccess, clientKey,urlApi } from "../../../global/utils";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import { jsPDF } from "jspdf";

export default {
  data() {
    return {
      contrato: {},
      content:{},
      cadastro: {
        tsPreenchimento:null,
        preenchida:true
      },
      cadastroid: null,
       servico: null,
      textoAjuda: null,
      popupActivo: false,
   };
  },components:{
  },

  mounted() {
    this.fnGetContratacao();
  },
  methods: {
    print: function(){
      window.print();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
    createPDF () {
    let pdfName = 'test'; 
    var doc = new jsPDF();
    doc.text("Hello World", 10, 10);
    doc.save(pdfName + '.pdf');
  },
    async fnGetContratacao(){
      await this.$http
        .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_13`)
        .then((res) => {
          this.contrato = res.data;
          if(res.data.contratacoesEVO13 != null){
            this.cadastro = res.data.contratacoesEVO13
          }
        })
        .catch(() => {});
              await this.$http
        .get(`contratacao/lista/impimir/${this.$route.params.codigoContrato}`)
        .then((res) => {
          this.servico = res.data.servicos;
          this.textoAjuda = this.servico.textoAjuda13;
          this.content = res.data;
        }).then(() => {this.print()});


  },
   async fnDownload() {
      const imgUrl =
        urlApi + "Upload/" + this.$route.params.codigoContrato + "/etapa13/";
      window.open(imgUrl + this.contrato.arquivoEstudo);
      await this.$http.put("/contratacao/download/"+this.$route.params.codigoContrato+"/"+this.contrato.contratacaoId)
      .then(() => {
       
      })
      .catch(() => {});
    },

    async fnCadastra(e) {
      e.preventDefault();
      const metodo = this.cadastro.etapaId ? "put" : "post";
      this.cadastro.tsPreenchimento = this.$moment().format("YYYY-MM-DD HH:mm");
      this.cadastro.ContratacaoId = this.contrato.contratacaoId
      const completaUrl = this.cadastro.etapaId
        ? "/" + this.cadastro.etapaId
        : "";
    await this.$http[metodo]("/etapa_13" + completaUrl, this.cadastro)
      .then((res) => {
        this.cadastro = res.data
        getSuccess();
          window.location.reload(true);

      })
      .catch(() => {});
    },
    convertToken(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    },
    async fnDeletar(val) {
      var token = localStorage.getItem(clientKey);
      var dataToken = this.convertToken(token);
      await this.$http
        .delete(`/etapa_12/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map((item) => item.etapaId).indexOf(val);
          this.content.splice(i, 1);
          getSuccess();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user {
  width: 120%;
}
</style>